"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _MarginAlert = require("./MarginAlert");
Object.keys(_MarginAlert).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _MarginAlert[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _MarginAlert[key];
    }
  });
});